// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./hyper-log-catcher/ErrorBoundary.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./Payments/PaymentMethodsRecord.bs.js";
import * as PaymentRequestButtonElement$OrcaPaymentPage from "./Payments/PaymentRequestButtonElement.bs.js";

function WalletElement(props) {
  var sessionsObj = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.sessions);
  var methodslist = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var match = React.useState(function () {
        return {};
      });
  var setSessions = match[1];
  var sessions = match[0];
  var match$1 = React.useState(function () {
        return [];
      });
  var setWalletOptions = match$1[1];
  var walletOptions = match$1[0];
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var setPaymentMethodListValue = Recoil.useSetRecoilState(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var match$3 = PaymentUtils$OrcaPaymentPage.useGetPaymentMethodList(props.paymentType, sessions);
  var walletList = match$3[0];
  React.useEffect((function () {
          if (typeof methodslist === "object" && methodslist.TAG === "Loaded") {
            var pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(methodslist._0));
            setWalletOptions(function (param) {
                  return walletList;
                });
            setPaymentMethodListValue(function (param) {
                  return pList;
                });
          }
          
        }), [
        methodslist,
        walletList
      ]);
  React.useEffect((function () {
          if (typeof sessionsObj === "object" && sessionsObj.TAG === "Loaded") {
            var ssn = sessionsObj._0;
            setSessions(function (param) {
                  return ssn;
                });
          }
          
        }), [sessionsObj]);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: walletOptions.length > 0,
              children: React.createElement("div", {
                    className: "flex flex-col place-items-center"
                  }, JsxPPXReactSupportU.createElementWithKey("payment_request_buttons_all", ErrorBoundary$OrcaPaymentPage.make, {
                        children: React.createElement(PaymentRequestButtonElement$OrcaPaymentPage.make, {
                              sessions: sessions,
                              walletOptions: walletOptions
                            }),
                        level: "RequestButton",
                        componentName: "WalletElement",
                        publishableKey: match$2.publishableKey
                      }))
            });
}

var make = WalletElement;

export {
  make ,
}
/* react Not a pure module */
